import Cookies from 'js-cookie';
import { computed, makeObservable } from 'mobx';
import { NavigateFunction } from 'react-router-dom';

import { AsyncState } from 'shared/libs/state';
import { TelegramStatsApiService } from './telegram-stats.api-service';
import {
   TelegramStatsData,
   TelegramStatsMetric,
   TelegramStatsResponse,
} from './telegram-stats.types';

const telegramStatsLabels: Record<keyof TelegramStatsData, string> = {
   subscriptions: 'Підписки',
   cabinet_clicks: 'Кліки в кабінеті',
   search_clicks: 'Кліки в пошуку',
   telegram_apply: 'Заявки через Telegram',
   unsubscribe: 'Скасування підписки',
   next_clicks: 'Кліки «Далі»',
   previous_clicks: 'Кліки «Назад»',
};

const telegramStatsOrder: (keyof TelegramStatsData)[] = [
   'subscriptions',
   'cabinet_clicks',
   'search_clicks',
   'telegram_apply',
   'unsubscribe',
   'next_clicks',
   'previous_clicks',
];

export class TelegramStatsStore {
   readonly loadTelegramStatsState = new AsyncState<TelegramStatsResponse>();

   constructor(private readonly navigate: NavigateFunction) {
      makeObservable(this, {
         data: computed,
         rows: computed,
         isLoading: computed,
         isError: computed,
      });
   }

   get data(): TelegramStatsData | null {
      const response = this.loadTelegramStatsState.data;

      if (!response) {
         return null;
      }

      if ('response' in response) {
         return response.response;
      }

      return response;
   }

   get rows(): TelegramStatsMetric[] {
      const data = this.data;

      if (!data) {
         return [];
      }

      return telegramStatsOrder.map((key) => ({
         key,
         label: telegramStatsLabels[key],
         value: data[key],
      }));
   }

   get isLoading(): boolean {
      return (
         this.loadTelegramStatsState.status === 'idle' ||
         this.loadTelegramStatsState.status === 'pending'
      );
   }

   get isError(): boolean {
      return this.loadTelegramStatsState.status === 'error';
   }

   async loadTelegramStats(): Promise<void> {
      const tokenKey = Cookies.get('token');

      if (!tokenKey) {
         this.navigate('/admin');
         return;
      }

      await this.loadTelegramStatsState.run(() => TelegramStatsApiService.load());
   }
}
